import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import Helmet from 'react-helmet';
import axios from 'axios';
import baseUrl from '../../utils/baseUrl';
import { dispatchError, dispatchMsg } from '../../actions/errors';

import connect from '../../utils/connect';
import {
	redirectToPathIf,
	ROLE_ACCOUNT,
	ROLE_MEMBER,
	ROLE_ADMIN,
	ROLE_JUDGE,
	FWA_ADMIN,
	ROLE_JUDGE_FOTD,
	ROLE_JUDGE_FOTM,
	ROLE_JUDGE_FOTY,
	ROLE_JUDGE_TCEA,
} from '../../utils/authorization';
import { accountRoute } from '../../routes';

import { logout } from '../../actions/users';

import Dropdown from '../../components/dropdown/dropdown';
import Splitter from '../../components/account/block/splitter';

import css from './account.scss';

const SHOW_USER_HEAD       = 0;
const SHOW_PROFILE_HEAD    = 1;

class Account extends Component {
	static propTypes = {
		browser: PropTypes.object.isRequired,
		router: PropTypes.object.isRequired,
		dispatch: PropTypes.func.isRequired,
	};

	constructor(props) {
		super();

		this.state = {
			show: SHOW_USER_HEAD,
		};
	}

	componentWillMount(props) {
		redirectToPathIf(this.props.dispatch, accountRoute('/login'), !this.props.users.isLoggedIn(), location.pathname);
	}

	componentWillReceiveProps(nProps) {
		redirectToPathIf(nProps.dispatch, accountRoute('/login'), !nProps.users.isLoggedIn(), location.pathname);
	}

	componentDidMount() {
		if (this.props.router && this.props.router.location && this.props.router.location.query && this.props.router.location.query.c) {
			axios.post(`${baseUrl}/api/account/changerequest/${this.props.router.location.query.c}`)
			.then((res) => {
				if (res.data && res.data.message) {
					this.props.dispatch(dispatchMsg(res.data));
				}
			})
			.catch((res) => {
				if (res.data && res.data.message) {
					this.props.dispatch(dispatchError(res.data));
				}
			});
		}
	}

	render() {
		return (
			<div className='account'>
				<Helmet title='The FWA - Account' />
				<div className={'account__head' + (this.state.show === SHOW_USER_HEAD ? ' account__head--user-active' : ' account__head--profile-active')}>

					<div className='span5 span14-mobile account__head__user'>
						<div className='account__signout hide-desktop hide-tablet'>
							<button className='button button--dark' onClick={this.signOut.bind(this)}>Sign out</button>
						</div>

						{this.renderHeadSwitcher('Company profile', 'button--go')}

						<header className='hide-mobile account__head__label'>Your user</header>
						<h2 className='account__head__name'>{this.props.users.name}</h2>

						<ol className='account__head__menu'>
							<li><Link to={accountRoute('/settings')} activeClassName='active' >Account</Link></li>
							{this.props.users.canHas([ROLE_JUDGE_FOTD, ROLE_JUDGE_FOTM, ROLE_JUDGE_FOTY, ROLE_JUDGE_TCEA]) && (
								<li><Link to={accountRoute('/jury')} activeClassName='active' >Jury</Link></li>
							)}

							{this.props.users.editorials && !!this.props.users.editorials.length && (
								<li className='account__head__menu__expanded'>
									<Link to={accountRoute('/editorial')} activeClassName='active' onClick={(e) => e.preventDefault()}>
										<span ref='accountEditorial'>Editorial</span>
									</Link>
									<Dropdown attachTo={() => this.getRef('accountEditorial')} pointTo='TOP_LEFT' browser={this.props.browser}>
										<ol>
											{this.props.users.editorials.map((item, i) => {
												return (<li key={i}><Link to={accountRoute('/editorial/' + item.slug)} >{item.name}</Link></li>);
											})}
										</ol>
									</Dropdown>
								</li>
							)}
						</ol>

					</div>
					<div className='span9 span14-mobile account__head__profile'>
						<div className='account__signout'>
							<button className='button button--dark' onClick={this.signOut.bind(this)}>Sign out</button>
						</div>

						{this.renderHeadSwitcher('User profile', 'button--go-back')}

						{this.isPartOfProfile() && (<header className='hide-mobile account__head__label'>Part of the profile</header>)}
						{this.isPartOfProfile() && (<h2 className='account__head__name'>{this.props.users.profile.name}</h2>)}

						<ol className='account__head__menu'>
							<li><Link to={accountRoute('/profile/settings')} activeClassName='active' >Profile</Link></li>
							<li><Link to={accountRoute('/profile/projects')} activeClassName='active' >Projects</Link></li>
							<li><Link to={accountRoute('/profile/jobs')} activeClassName='active' >Jobs</Link></li>

							{this.isPartOfProfile() && this.props.users.profile.editorials && !!this.props.users.profile.editorials.length && (
								<li className='account__head__menu__expanded'>
									<Link to={accountRoute('/profile/editorial')} activeClassName='active' onClick={(e) => e.preventDefault()}>
										<span ref='profileEditorial'>Editorial</span>
									</Link>
									<Dropdown attachTo={() => this.getRef('profileEditorial')} browser={this.props.browser}>
										<ol>
											{this.props.users.profile.editorials.map((item, i) => {
												return (<li key={i}><Link to={accountRoute('/profile/editorial/' + item.slug)} >{item.name}</Link></li>);
											})}
										</ol>
									</Dropdown>
								</li>
							)}

							{this.props.users.canHas([FWA_ADMIN]) && (
								<li>
									<Link to={accountRoute('/admin')} activeClassName='active' onClick={(e) => e.preventDefault()}>
										<span ref='accountAdmin'>Admin</span>
									</Link>
									<Dropdown attachTo={() => this.getRef('accountAdmin')} pointTo='TOP_LEFT' browser={this.props.browser}>
										<ol>
											<li><Link to={accountRoute('/admin/jury-overview')}>Jury Overview</Link></li>
										</ol>
									</Dropdown>
								</li>
							)}
						</ol>

					</div>
					<div className='cf'></div>
				</div>

				<Splitter />

				{this.props.children || (<div></div>)}
			</div>
		);
	}

	getRef(name) {
		return this.refs[name];
	}

	isPartOfProfile() {
		return !!this.props.users.profile;
	}

	renderHeadSwitcher(text, buttonClass = '') {
		return (
			<div className='hide-desktop hide-tablet account__head-switch'>
				<button className={'button ' + (buttonClass ? ' ' + buttonClass : '')} onClick={this.switchActiveHead.bind(this)}>
					{text}
				</button>
			</div>
		);
	}

	switchActiveHead() {
		this.setState({
			...this.state,
			show: this.state.show === SHOW_USER_HEAD ? SHOW_PROFILE_HEAD : SHOW_USER_HEAD,
		});
	}

	signOut() {
		this.props.dispatch(logout());
	}
}

export default connect(Account);



/** WEBPACK FOOTER **
 ** ./frontend/containers/account/account.js
 **/